
<ng-template #customerContent>
  <div style="flex: 1; overflow-y: hidden">
    <div style="height: 100%; width: 100%; max-width: 100%; overflow-y: auto">
      <div style="padding: 16px">
        <div class="row-layout">
          <div style="flex: 1">
            <mat-form-field style="width: 10rem" floatLabel="always">
              <mat-label>Anrede</mat-label>
              <mat-select [formControl]="typesFC">
                <mat-option *ngFor="let s of types" [value]="s">{{
                  s.text
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div style="flex: 1; margin-left: 2rem">
            <app-input
              label="Telefonnummer"
              [(value)]="data.phone"
              name="phone"
              [maxlength]="phoneLength"
            ></app-input>
          </div>
        </div>

        <div class="row-layout">
          <div style="flex: 1">
            <app-input
              #fname
              label="Vorname"
              [required]="true"
              [(value)]="data.first_name"
              name="firstname"
              [maxlength]="firstNameLength"
            ></app-input>
          </div>

          <div style="flex: 1; margin-left: 2rem">
            <app-input
              label="Nachname"
              #lname
              [required]="true"
              [(value)]="data.last_name"
              name="lastname"
              [maxlength]="lastNameLength"
            ></app-input>
          </div>
        </div>

        <div class="row-layout">
        <div style="flex: 1">
          <app-input
            #address
            label="Straße und Hausnummer"
            [(value)]="data.address"
            name="address"
            [maxlength]="addressLength"
          ></app-input>
        </div>
        </div>

        <div class="input-row">
          <div style="width: 10rem">
            <app-input label="PLZ" [(value)]="data.zip" name="zip"
            [maxlength]="zipLength"></app-input>
          </div>
          <div style="flex: 1; margin-left: 2rem">
            <app-input
              label="Ort"
              [(value)]="data.city"
              name="city"
              [maxlength]="cityLength"
            ></app-input>
          </div>
        </div>

        <app-user-autocomplete
          name="partner"
          #partnerRef
          [(value)]="partner"
          label="Vermittler"
          [required]="true"
          [url]="partnersUrl"
        >
        </app-user-autocomplete>
      </div>
    </div>
  </div>
</ng-template>
<div *ngIf="isDialog">
  <h2 mat-dialog-title style="text-align:center">Neuer Kunde</h2>
  <mat-dialog-content class="mat-typography">
    <ng-container *ngTemplateOutlet="customerContent"></ng-container>
  </mat-dialog-content>
  <div mat-dialog-actions style="width: 100%">
    <div class="row-layout" style="justify-content: flex-end; width: 100%">
      <button mat-button (click)="closeDialog()"
      style="margin-right: 16px">Schließen</button>
      <button mat-icon-button (click)="saveDialog()"
      class="light-bg-color full-size-button">
        <mat-icon>save</mat-icon>
      </button>
      <!--Erstellen-->
    </div>
  </div>
</div>
<div class="edit-orders-content" *ngIf="!isDialog">
  <div>
    <div
      class="edit-orders-header"
      style="display: flex; flex-direction: row; justify-content: space-between"
    >
      <div>Allgemeine Kundendaten</div>
      <div *ngIf="blocked || deleted"
      style="background-color: white; color:red; font-size: 1.2rem;">
      <ng-container *ngIf="blocked">Gesperrt</ng-container>
      <ng-container *ngIf="deleted">Gelöscht</ng-container>
      </div>
      <div
        style="display: flex; flex-direction: row; justify-content: flex-end"
      >
        <div style="margin-right: 24px">
          <button mat-icon-button (click)="clickSave()">
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <div style="margin-right: 24px">
          <button mat-icon-button (click)="clickCancel()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="customerContent"></ng-container>
</div>
